export { useAPIFetchPartner } from './fetch-partner.hook';
export type { TAPIFetchPartnerResponse } from './fetch-partner.types';
